export const environment = {
  production: true,
  qa: false,
  ENVIRONMENT_NAME: '${ENVIRONMENT_NAME}'
};
